/**
 * @author Tamara Bazko
 */
import baseInitialize from './base';
import StaticMap from 'components/staticMap/StaticMapManager';
import ShopDetailComponent from 'components/storeFinder/ShopDetailComponent';

baseInitialize();

StaticMap.initialize();
ShopDetailComponent.initialize();
